export class DeleteAdministratorModel {
    public adminId : string;
}